import { render, staticRenderFns } from "./CardCompare.vue?vue&type=template&id=3a8319a3&scoped=true&"
import script from "./CardCompare.vue?vue&type=script&lang=js&"
export * from "./CardCompare.vue?vue&type=script&lang=js&"
import style0 from "./CardCompare.vue?vue&type=style&index=0&id=3a8319a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8319a3",
  null
  
)

export default component.exports